import * as _ from 'lodash';

import ISubZone = ZoneIQCalibration.ISubZone;

export class SubZoneModel implements ISubZone {
    public Id: number;
    public RevisionId: number;
    public Name: string;
    public Alias: string;
    public ZoningCodeId: number;
    public CloneId: number;

    constructor(data: ISubZone) {
        Object.assign(this, _.pick(data, ['Id', 'RevisionId', 'Name', 'Alias', 'ZoningCodeId', 'CloneId']));
    }

    static factory(data: ISubZone) {
        return new SubZoneModel(data);
    }
}
